import { loadStripe } from '@stripe/stripe-js'

/**
 * Extend Default Settings
 * Extends the default settings of an object.
 * Default properies will be overwritten if the same key matches.
 * This is a shallow extension only useful for simple (single level) objects.
 * @param {object} defaults
 * @param {object} settings
 */
export const extendDefaultSettings = (defaults, settings) => {
  for (const key in settings) {
    if (Object.prototype.hasOwnProperty.call(settings, key)) {
      defaults[key] = settings[key]
    }
  }

  return defaults
}

/**
 * Has Callback
 * Checks if object is a valid function.
 * @param {object} styleProperty
 * @return {boolean}
 */
export const hasCallback = (callback) => {
  return callback && typeof callback === 'function'
}

/**
 * Get Order Status
 * Returns a matching order status name.
 * If no match is found the status code is returned.
 * @param {string} code
 * @return {string}
 */
export const getOrderStatus = (code = '') => {
  const statuses = {
    C: 'Completed',
    X: 'Cancelled'
  }

  for (const [key, value] of Object.entries(statuses)) {
    if (key === code) {
      return value
    }
  }

  if (code === '') {
    return 'Open'
  }

  return code
}

/**
 * Convert to Title Case
 * @link https://gist.github.com/kieranbarker/293b74f1b3b46272315d2e1719786b03
 * @param {string} str
 * @returns {string}
 */
export const convertToTitleCase = (str) => {
  return str.toLowerCase().split(' ').map(function (word) {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join(' ')
}

/**
 * Removes empty object keys from an object
 * @param {object} obj
 * @returns {object}
 */
export const removeEmptyObjectKeys = (obj = {}) => (
  Object.keys(obj).reduce((accumulator, key) => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      accumulator[key] = obj[key]
    }
    return accumulator
  }, {})
)

/**
 * Get Stripe for Currency
 * @param currency
 * @returns {Promise<Stripe | null>}
 */
export const loadStripeForCurrency = (currency) => {
  let stripeSecret = null

  switch (currency) {
    case 'EUR':
      stripeSecret = process.env.MIX_STRIPE_MODE === 'live' ? process.env.MIX_STRIPE_LIVE_SECRET_EUR : process.env.MIX_STRIPE_TEST_SECRET_EUR
      break
    case 'USD':
      stripeSecret = process.env.MIX_STRIPE_MODE === 'live' ? process.env.MIX_STRIPE_LIVE_SECRET_USD : process.env.MIX_STRIPE_TEST_SECRET_USD
      break
    case 'CAD':
      stripeSecret = process.env.MIX_STRIPE_MODE === 'live' ? process.env.MIX_STRIPE_LIVE_SECRET_CAD : process.env.MIX_STRIPE_TEST_SECRET_CAD
      break
    case 'AUD':
      stripeSecret = process.env.MIX_STRIPE_MODE === 'live' ? process.env.MIX_STRIPE_LIVE_SECRET_AUD : process.env.MIX_STRIPE_TEST_SECRET_AUD
      break
    default:
      stripeSecret = process.env.MIX_STRIPE_MODE === 'live' ? process.env.MIX_STRIPE_LIVE_SECRET_GBP : process.env.MIX_STRIPE_TEST_SECRET_GBP
      break
  }

  return loadStripe(stripeSecret)
}
